export default function getToken() {
    return localStorage.getItem('auth0_token')
}